// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1pVEK","col":"styles_col__21laA"};